import { Box } from "@mui/material";
import { useI18n } from "../../../i18";

const InactiveLabel = () => {
  const { t } = useI18n();
  return (
    <Box
      sx={{
        color: "white",
        background: "var(--mui-palette-grey-600)",
        borderRadius: "4px",
        py: 0.3,
        px: 0.8,
        fontSize: 12,
        lineHeight: 1.15,
      }}
    >
      {t("inactive")}
    </Box>
  );
};

export default InactiveLabel;
